module.exports = __webpack_public_path__ + "static/media/llanta-desgaste-desparejo-red.791f3cdd.svg";